import React from 'react';
import './Dropdown.css';
import DropdownItems from '../navItems/Items';

export default class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.toggleIcon = React.createRef();
  }
  
  state = {
    isCollapsed: true,
    iconRotate: 0
  }

  handleToggleCollapse = (numOfItems) => {
    const target = document.querySelector(".dropdown-items");
    const height = 39.4 * numOfItems + "px";

    this.setState({ isCollapsed: !this.state.isCollapsed },
      () => {
        this.state.isCollapsed
        ?target.style.height = "0px"
        :target.style.height = height
      }
    )
  }

  handleToggleIconAnimation = () => {
    const toggleIcon = this.toggleIcon.current;

    this.setState({iconRotate: this.state.iconRotate === 360? 45 : this.state.iconRotate+45},
      () => {
        toggleIcon.style.transform = `rotate(${this.state.iconRotate}deg)`;
      }
    )
  }
  
  render() {
    const { items } = this.props;

    return (
      <div className="dropdown" onClick={() => {
        this.handleToggleIconAnimation()
        this.handleToggleCollapse(items.length)
        }}>
          <div
            className="dropdown-toggle"
          >
            <i className="fas fa-vector-square" ref={this.toggleIcon}></i>
          </div>
          
          <DropdownItems
            items={this.props.items}
            className="dropdown-items"
          />
      </div>
    )
  }
}